import { IcLikeFilled, LikeTypography, Typography } from '@musinsa/mds';
import type { FC } from 'react';

const DISPLAY_NAME = 'ProductInformation.HeartLikeCount';

interface Props {
  likeCount: number;
}

export const HeartLikeCount: FC<Props> = ({ likeCount }) => (
  <>
    <IcLikeFilled fillColor="red" strokeColor="transparent" width="12px" height="12px" />
    <Typography variant="textEtc11pxReg" colorScheme="red">
      <LikeTypography likeCount={likeCount} />
    </Typography>
  </>
);

HeartLikeCount.displayName = DISPLAY_NAME;
